import { create } from 'zustand';

interface LimitStore {
  limit: number;
  setLimit: (limit: number) => void;
}

const useLimitStore = create<LimitStore>((set) => ({
  limit: 0,
  setLimit: (limit: number) => set({ limit }),
}));

export default useLimitStore;
